<template>
  <div class="cookie-consent-container">
    <!-- Cookie底部授权条 -->
    <div class="cookie-bottom-bar" id="cookieBottomBar" ref="cookieBar" style="display: none;">
      <div class="cookie-bar-content">
        <div class="cookie-bar-text">
          We use cookies to improve your experience on our site. We store session data, usage analytics, and
          personalized preferences.
          <a href="javascript:;" class="cookie_nr" @click="openCookiePolicy">Learn more about our cookie policy</a>.
        </div>
        <div class="cookie-bar-buttons">
          <button class="cookie-bar-btn btn-bar-settings" id="barSettings">Settings</button>
          <button class="cookie-bar-btn btn-bar-accept" id="barAccept">Accept All</button>
        </div>

        <!-- Cookie设置面板 -->
        <div class="cookie-settings-panel" id="cookieSettingsPanel" ref="settingsPanel">
          <h3 class="settings-panel-title">Cookie Preferences</h3>

          <!-- 必要Cookie（不可禁用） -->
          <div class="cookie-option">
            <div class="toggle-switch checked disabled" id="essentialToggle"></div>
            <label>
              Essential Cookies
              <div class="cookie-option-desc">Required for website functionality (cannot be disabled)</div>
            </label>
          </div>

          <!-- 分析Cookie -->
          <div class="cookie-option">
            <div class="toggle-switch checked" id="analyticsToggle"></div>
            <label>
              Analytics Cookies
              <div class="cookie-option-desc">Store: Page visits, interaction data. Purpose: Improve website performance
              </div>
            </label>
          </div>

          <!-- 营销Cookie -->
          <div class="cookie-option">
            <div class="toggle-switch checked" id="marketingToggle"></div>
            <label>
              Marketing Cookies
              <div class="cookie-option-desc">Store: Interest data, ad preferences. Purpose: Personalize content</div>
            </label>
          </div>

          <button class="settings-save-btn" id="saveSettings">Save Preferences</button>
        </div>
      </div>
    </div>

    <!-- Cookie政策详情弹窗 -->
    <div class="cookie" v-show="cookiePolicyVisible">
      <div class="cookie_wz">
        <div class="ck_gb" @click="closeCookiePolicy"><i class="iconfont icon-guanbi1"></i></div>
        <div class="b_t">Cookie Policy</div>
        <div class="n_r">
          <div class="w_z">
            <h3>1. What Are Cookies?</h3>
            <p>Cookies are small text files that are stored on your device (computer, mobile phone, tablet, etc.) when
              you visit a website. They are used to record information in order to improve your browsing experience,
              remember your preferences, analyze website traffic, and more.</p>
          </div>
          <div class="w_z">
            <h3>2. Why Do We Use Cookies?</h3>
            <p>We use cookies for the following purposes:</p>
            <ul>
              <li>Essential Cookies: To ensure basic website functionality operates correctly (e.g., login, shopping
                cart).</li>
              <li>Preference Cookies: To remember your personalized settings such as language preference and font size.
              </li>
              <li>Analytical/Performance Cookies: To collect anonymous data that helps us understand how users interact
                with our website, allowing us to improve content and design.</li>
              <li>Marketing/Targeting Cookies: To track advertising effectiveness and display content that may be of
                interest to you (may be provided by third-party services).</li>
            </ul>
          </div>
          <div class="w_z">
            <h3>3. What Types of Cookies Do We Use?</h3>
            <div class="x_x">
              <table width="100%" border="1">
                <tr>
                  <th scope="col">Type</th>
                  <th scope="col">Provider</th>
                  <th scope="col">Purpose</th>
                  <th scope="col">Duration</th>
                </tr>
                <tr>
                  <td>Essential Cookies</td>
                  <td>This website</td>
                  <td>Maintain core website functionality</td>
                  <td>Session / Persistent</td>
                </tr>
                <tr>
                  <td>Preference Cookies</td>
                  <td>This website</td>
                  <td>Remember user settings</td>
                  <td>Persistent</td>
                </tr>
                <tr>
                  <td>Analytical Cookies</td>
                  <td>Google Analytics, etc.</td>
                  <td>Analyze traffic and user behavior</td>
                  <td>Persistent</td>
                </tr>
                <tr>
                  <td>Advertising Cookies</td>
                  <td>Third-party ad platforms</td>
                  <td>Deliver personalized ads</td>
                  <td>According to third-party policies</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="w_z">
            <h3>4. Third-Party Cookies</h3>
            <p>We may work with third-party partners (such as analytics services, social media platforms, and
              advertisers) who may set cookies through our website to provide their services (e.g., data analysis, ad
              delivery). We do not control how third parties use cookies, and we recommend that you review their
              respective privacy policies.</p>
          </div>
          <div class="w_z">
            <h3>5. How Can You Manage Cookies?</h3>
            <ul>
              <li>Browser Settings: You can refuse, delete, or selectively accept cookies through your browser settings.
                For instructions, please refer to your browser's help page (e.g., Chrome, Firefox, Safari).</li>
              <li>Opt-Out Options: For specific third-party analytical or advertising cookies, you may opt out via the
                following links:<br>
                - <a href="https://tools.google.com/dlpage/gaoptout" target="_blank">Google Analytics Opt-Out</a><br>
                - <a href="https://optout.aboutads.info/" target="_blank">Network Advertising Initiative Opt-Out</a>
              </li>
              <li>Note: Disabling cookies may affect certain website features (e.g., login, preference settings).</li>
            </ul>
          </div>
          <div class="w_z">
            <h3>6. Policy Updates</h3>
            <p>We may update this policy from time to time to reflect changes in technology, law, or business practices.
              The updated version will be posted on this page with a revised "Last Updated" date.</p>
          </div>
          <div class="w_z">
            <h3>7. Contact Us</h3>
            <p>If you have any questions about this Cookie Policy, please contact us at:</p>
            <ul>
              <li>Email: info@cnhonorgroup.com</li>
              <li>Address: #333 ANKANG ROAD, HIGH-TECH ZONE, BINZHOU, SHANDONG, CHINA</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { saveData, readData } from '@/utils/myutils';
export default {
  name: 'CookieConsent',
  data() {
    return {
      // Cookie政策弹窗显隐
      cookiePolicyVisible: false,
      // 存储DOM元素引用
      elements: {
        cookieBottomBar: null,
        cookieSettingsPanel: null,
        barSettings: null,
        barAccept: null,
        saveSettings: null,
        analyticsToggle: null,
        marketingToggle: null
      }
    }
  },
  mounted() {
    // 初始化DOM元素引用
    this.initElements();
    // 绑定所有事件监听
    this.bindEventListeners();
    // 页面加载时检查Cookie授权状态
    this.checkCookieConsentOnLoad();
  },
  beforeDestroy() {
    // 移除事件监听，防止内存泄漏
    this.unbindEventListeners();
  },
  methods: {
    /**
     * 初始化DOM元素引用
     */
    initElements() {
      this.elements.cookieBottomBar = document.getElementById('cookieBottomBar');
      this.elements.cookieSettingsPanel = document.getElementById('cookieSettingsPanel');
      this.elements.barSettings = document.getElementById('barSettings');
      this.elements.barAccept = document.getElementById('barAccept');
      this.elements.saveSettings = document.getElementById('saveSettings');
      this.elements.analyticsToggle = document.getElementById('analyticsToggle');
      this.elements.marketingToggle = document.getElementById('marketingToggle');
    },

    /**
     * 绑定所有原生事件监听
     */
    bindEventListeners() {
      const { barSettings, analyticsToggle, marketingToggle, barAccept, saveSettings } = this.elements;

      // 打开/关闭设置面板
      if (barSettings) {
        barSettings.addEventListener('click', this.toggleSettingsPanel);
      }

      // 切换分析Cookie开关
      if (analyticsToggle) {
        analyticsToggle.addEventListener('click', this.toggleAnalyticsToggle);
      }

      // 切换营销Cookie开关
      if (marketingToggle) {
        marketingToggle.addEventListener('click', this.toggleMarketingToggle);
      }

      // 接受所有Cookie
      if (barAccept) {
        barAccept.addEventListener('click', this.acceptAllCookies);
      }

      // 保存自定义设置
      if (saveSettings) {
        saveSettings.addEventListener('click', this.saveCustomSettings);
      }
    },

    /**
     * 移除所有事件监听
     */
    unbindEventListeners() {
      const { barSettings, analyticsToggle, marketingToggle, barAccept, saveSettings } = this.elements;

      if (barSettings) {
        barSettings.removeEventListener('click', this.toggleSettingsPanel);
      }

      if (analyticsToggle) {
        analyticsToggle.removeEventListener('click', this.toggleAnalyticsToggle);
      }

      if (marketingToggle) {
        marketingToggle.removeEventListener('click', this.toggleMarketingToggle);
      }

      if (barAccept) {
        barAccept.removeEventListener('click', this.acceptAllCookies);
      }

      if (saveSettings) {
        saveSettings.removeEventListener('click', this.saveCustomSettings);
      }
    },

    /**
     * 页面加载时检查Cookie授权状态
     */
    checkCookieConsentOnLoad() {
      const consent = localStorage.getItem('cookieConsent');
      // 无授权记录时显示授权条
      if (!consent) {
        this.elements.cookieBottomBar.style.display = 'block';
      } else {
        // 有授权记录时，恢复开关状态（针对自定义设置）
        this.restoreToggleStates(consent);
      }
    },

    /**
     * 恢复开关状态（从本地存储）
     * @param {String} consent - 本地存储的授权值
     */
    restoreToggleStates(consent) {
      const { analyticsToggle, marketingToggle } = this.elements;

      if (consent === 'all') {
        // 接受所有：两个开关都设为checked
        analyticsToggle.classList.add('checked');
        marketingToggle.classList.add('checked');
      } else if (consent) {
        // 自定义设置：解析JSON并恢复状态
        try {
          const preferences = JSON.parse(consent);
          if (preferences.analytics) {
            analyticsToggle.classList.add('checked');
          } else {
            analyticsToggle.classList.remove('checked');
          }

          if (preferences.marketing) {
            marketingToggle.classList.add('checked');
          } else {
            marketingToggle.classList.remove('checked');
          }
        } catch (e) {
          console.error('解析Cookie偏好失败:', e);
        }
      }
    },

    /**
     * 打开/关闭设置面板
     */
    toggleSettingsPanel() {
      this.elements.cookieSettingsPanel.classList.toggle('active');
    },

    /**
     * 切换分析Cookie开关
     */
    toggleAnalyticsToggle() {
      const { analyticsToggle } = this.elements;
      if (!analyticsToggle.classList.contains('disabled')) {
        analyticsToggle.classList.toggle('checked');
      }
    },

    /**
     * 切换营销Cookie开关
     */
    toggleMarketingToggle() {
      const { marketingToggle } = this.elements;
      if (!marketingToggle.classList.contains('disabled')) {
        marketingToggle.classList.toggle('checked');
      }
    },

    /**
     * 接受所有Cookie
     */
    acceptAllCookies() {
      // localStorage.setItem('cookieConsent', 'all');
      this.elements.cookieBottomBar.style.display = 'none';
      saveData('cookieConsent', 'all');
      // alert('All cookies accepted - preference saved');

      // 同步更新开关状态为选中
      this.elements.analyticsToggle.classList.add('checked');
      this.elements.marketingToggle.classList.add('checked');
      // 关闭设置面板
      this.elements.cookieSettingsPanel.classList.remove('active');
    },

    /**
     * 保存自定义Cookie设置
     */
    saveCustomSettings() {
      const { analyticsToggle, marketingToggle, cookieBottomBar, cookieSettingsPanel } = this.elements;

      // 构建偏好设置对象
      const preferences = {
        essential: true,
        analytics: analyticsToggle.classList.contains('checked'),
        marketing: marketingToggle.classList.contains('checked')
      };

      // 保存到本地存储
      // localStorage.setItem('cookieConsent', JSON.stringify(preferences));
      saveData('cookieConsent', JSON.stringify(preferences));
      // 隐藏授权条和设置面板
      cookieBottomBar.style.display = 'none';
      cookieSettingsPanel.classList.remove('active');
      // 提示用户
      // alert(`Settings saved: Analytics=${preferences.analytics}, Marketing=${preferences.marketing}`);

      // saveData('cookieConsent', 'true');

    },

    /**
     * 打开Cookie政策详情弹窗
     */
    openCookiePolicy() {
      this.cookiePolicyVisible = true;
      // 打开弹窗时关闭设置面板
      this.elements.cookieSettingsPanel.classList.remove('active');
    },

    /**
     * 关闭Cookie政策详情弹窗
     */
    closeCookiePolicy() {
      this.cookiePolicyVisible = false;
    }
  }
}
</script>
